import relxLogo from "../../assets/images/relx-logo.png";
import { appendUtmParamsToLinks } from "../../utils/utility";

interface FooterProps {
  data?: string;
  logo: string;
  logoAlt: string;
}

const Footer = (props: FooterProps) => {
  let htmlContent = "";
  if (props.data) htmlContent = props.data;
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const extractedText = doc.body.textContent;
  // Get the current year
  const currentYear = new Date().getFullYear();

  // Replace the year in the extracted text
  let updatedText = extractedText
    ? extractedText.replace("{{currentYear}}", currentYear.toString())
    : "";

  const cookieSettingsLi = `<li><button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie&nbsp;Settings</button></li>`;

  updatedText = updatedText.replace("</ul>", cookieSettingsLi + "\n</ul>");

  const modifiedText = appendUtmParamsToLinks(updatedText);
  return (
    <>
      <div id="page-footer" className="md:footer-container-list">
        <div className="footer-ln-components-list">
          <div
            dangerouslySetInnerHTML={{
              __html: modifiedText ? modifiedText : "",
            }}
          />
        </div>
      </div>

      <div id="page-footer" className="footer-container">
        <div className="ln-logo">
          <img src={props.logo} alt={props.logoAlt} />
        </div>
        <div className="footer-ln-components">
          <div
            dangerouslySetInnerHTML={{
              __html: modifiedText ? modifiedText : "",
            }}
          />
        </div>
        <div className="rl-logo">
          <img src={relxLogo} alt="relx logo" />
        </div>
      </div>
    </>
  );
};

export default Footer;
